import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import util from "../util/util";
import InaccessibleLink from "../shim/inaccessible-link";

export default function PaginationPrevious(props) {
  if (props.currentPage === 1) {
    return (
      <li className="disabled">
        <InaccessibleLink aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </InaccessibleLink>
      </li>
    );
  } else {
    return (
      <li>
        <Link
          to={util.returnPaginationUrl(
            props.path,
            props.currentPage - 1,
            props.queryString
          )}
          aria-label="Previous"
        >
          <span aria-hidden="true">&laquo;</span>
        </Link>
      </li>
    );
  }
}

PaginationPrevious.propTypes = {
  currentPage: PropTypes.number,
  path: PropTypes.string,
  queryString: PropTypes.string
};
